/**
 * Border and radius helpers for vertically stacked criterion cards.
 */
import type { CriteriaCardBorderSide, CriteriaCardCorner } from "./CriteriaCard";

/**
 * Radius for a card in a vertically stacked list: top of first, bottom of last.
 *
 * @param index - Zero-based position in the stack
 * @param total - Number of cards in the stack
 * @returns Corners to round, or undefined to round all when the stack has one card
 */
export const getStackedRoundedCorners = (
    index: number,
    total: number,
): CriteriaCardCorner[] | undefined => {
    if (total <= 1) {
        return undefined;
    }
    if (index === 0) {
        return ["top-left", "top-right"];
    }
    if (index === total - 1) {
        return ["bottom-left", "bottom-right"];
    }
    return [];
};

/**
 * Borders for a card in a vertically stacked list: skip shared inner edges.
 *
 * @param index - Zero-based position in the stack
 * @param total - Number of cards in the stack
 * @returns Sides to border, or undefined for all sides when the stack has one card
 */
export const getStackedBorders = (
    index: number,
    total: number,
): CriteriaCardBorderSide[] | undefined => {
    if (total <= 1) {
        return undefined;
    }
    if (index === 0) {
        return ["top", "right", "bottom", "left"];
    }
    return ["right", "bottom", "left"];
};
